export { default } from '@esentai/core/features/salesTurnoverDetails/api';
